import Vue from 'vue'
import VueRouter from 'vue-router'
import ScreenPage from "@/views/ScreenPage";
import ScreenPageb from "@/views/ScreenPageb";
import ScreenPagec from "@/views/ScreenPagec";
import ScreenPaged from "@/views/ScreenPaged";
import EleScreen from "@/views/EleScreen";
import ScreenYs from "@/views/ScreenYs";
import ScreenAi from "@/views/ScreenAi";

Vue.use(VueRouter)

const routes = [
  {
    path: '/screenpage',
    component: ScreenPage
  },
  {
    path: '/screenpageb',
    component: ScreenPageb
  },
  {
    path: '/screenpaged',
    component: ScreenPaged
  },
  {
    path: '/screenpagec',
    component: ScreenPagec
  },
  {
    path: '/eleScreen',
    component: EleScreen
  },
  {
    path: '/screenYs',
    component: ScreenYs
  },
  {
    path: '/screenAi',
    component: ScreenAi
  }
]

const router = new VueRouter({
  routes
})

export default router
